<template>
  <div>
    <div class="card p-2 mb-2 bg-gray text-white text-uppercase heading-small">
      <div class="row ">
        <div class="col-md-1 font-heading">Eye</div>
        <div class="col-md-1 px-1 font-heading">Visus Awal</div>
        <div class="col-md-1 px-1 font-heading">PH</div>
        <div class="col-md-1 px-1 font-heading">TIO</div>
        <div class="col-md-2 px-1 font-heading">KM Lama</div>
        <div class="col-md-2 px-1 font-heading">Koreksi</div>
        <div class="col-md-1 px-1 font-heading">Visus Akhir</div>
        <div class="col-md-3 font-heading">Catatan</div>
      </div>
    </div>
    <div class="card p-2 mb-1">
      <div class="row">
        <div class="col-md-1 font-heading">O.D.</div>
        <div class="col-md-1 px-1 font-heading">{{ data.od_visus }}</div>
        <!-- INSERTED NEW data.od_ph -->
        <div class="col-md-1 px-1 font-heading">{{ data.od_ph }}</div>
        <!-- INSERTED NEW data.od_ph -->
        <div class="col-md-1 px-1 font-heading">{{ data.od_tio }}</div>
        <div class="col-md-2 px-1 font-heading">
          S ( {{ data.od_s_lama }} ) , C ( {{ data.od_c_lama }} ) , <br />X (
          {{ data.od_x_lama }} ) , Add ( {{ data.od_add_lama }} )
        </div>
        <div class="col-md-2 px-1 font-heading">
          S ( {{ data.od_s_kor }} ) , C ( {{ data.od_c_kor }} ) ,<br />X (
          {{ data.od_x_kor }} ) , Add ( {{ data.od_add_kor }} )
        </div>
        <!-- INSERTED NEW data.od_visus_new -->
        <div class="col-md-1 px-1 font-heading">{{ data.od_visus_akhir }}</div>
        <!-- INSERTED NEW data.od_visus_new -->
        <div class="col-md-3 font-heading">{{ data.od_catatan }}</div>
      </div>
    </div>
    <div class="card p-2">
      <div class="row">
        <div class="col-md-1 font-heading">O.S.</div>
        <div class="col-md-1 px-1 font-heading">{{ data.os_visus }}</div>
        <!-- INSERTED NEW data.os_ph -->
        <div class="col-md-1 px-1 font-heading">{{ data.os_ph }}</div>
        <!-- INSERTED NEW data.os_ph -->
        <div class="col-md-1 px-1 font-heading">{{ data.os_tio }}</div>
        <div class="col-md-2 px-1 font-heading">
          S ( {{ data.os_s_lama }} ) , C ( {{ data.os_c_lama }} ) , <br />X (
          {{ data.os_x_lama }} ) , Add ( {{ data.os_add_lama }} )
        </div>
        <div class="col-md-2 px-1 font-heading">
          S ( {{ data.os_s_kor }} ) , C ( {{ data.os_c_kor }} ) , <br />X (
          {{ data.os_x_kor }} ) , Add ( {{ data.os_add_kor }} )
        </div>
        <!-- INSERTED NEW data.os_visus_new -->
        <div class="col-md-1 px-1 font-heading">{{ data.os_visus_akhir }}</div>
        <!-- INSERTED NEW data.os_visus_new -->
        <div class="col-md-3 font-heading">{{ data.os_catatan }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TabelOphthalmic",
  components: {},
  props: {
    data: Object,
  },
  data: function() {
    return {};
  },
  methods: {},
  mounted: function() {
    //console.log(this.data);
  },
};
</script>
